import { LoadingSpinner, ScrollArea } from '@app/shared/ui/atoms/Common';
import { BackgroundImage, Title } from '@app/shared/ui/atoms/UserDataForm';
import { Form } from '@app/shared/ui/organisms/UserDataForm';
import { usePreloadImages } from '@app/shared/hooks/usePreloadImages';
import { USER_DATA_FORM_PRELOAD_IMAGES } from '@app/assets';

export default function UserDataFormPage() {
  const isImagesLoading = usePreloadImages(USER_DATA_FORM_PRELOAD_IMAGES);

  if (isImagesLoading) {
    return <LoadingSpinner />;
  }

  return (
    <ScrollArea className="relative bg-background-gradient px-7">
      <BackgroundImage />
      <div className="flex flex-1 flex-col justify-center">
        <Title />
        <Form />
      </div>
    </ScrollArea>
  );
}
